import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'neo-proximamente-dlg',
  templateUrl: './proximamente-dlg.component.html',
  styleUrls: ['./proximamente-dlg.component.scss']
})
export class ProximamenteDlgComponent implements OnInit {
  @Input() tituloDialog = 'Proximamente';
  @Input() descripcionDialog: string;
  @ViewChild('dialogProximamente') dialogProximamente: TemplateRef<any>;
  constructor(
    private dialogo: MatDialog
  ) { }

  ngOnInit(): void {
  }

  abrirDialogo() {
    this.dialogo.open(this.dialogProximamente, { disableClose: false, width: '540px', minWidth: '300px', panelClass: ['dialogoProximamente'] });
    // this.dialogo.open(this.dialogProximamente, { disableClose: true, width: '540px', minWidth: '300px', panelClass: ['dialogoMainCta'] });
  }

}
